let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kW5ll"), load("7GtpA")]).then(() => parcelRequire('Vjn6T'));